import React from "react";
import questionSVG from "./../../images/question.svg";

const FAQ = () => (
  <div className="bg-heropattern py-16" id="faq">
    <div className="w-5/6 max-w-xl mx-auto" data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
      <div className="font-bold font-title flex items-center justify-center py-8">
        <svg className="fill-current text-grey-darkest h-4 mr-2 inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm2-13c0 .28-.21.8-.42 1L10 9.58c-.57.58-1 1.6-1 2.42v1h2v-1c0-.29.21-.8.42-1L13 9.42c.57-.58 1-1.6 1-2.42a4 4 0 1 0-8 0h2a2 2 0 1 1 4 0zm-3 8v2h2v-2H9z"/>
        </svg>    
        <p className="font-bold font-title text-xl">Frequently Asked Questions</p>
      </div>
      <div className="px-6 py-4">
        <div>
         
          <span className="font-bold font-title">Do I need my own bicycle? 
          </span>
        </div>
        <p className="text-base font-body leading-normal">Nope! All tours include a knowledgeable guide, quality bicycle, and helmet.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">This looks fun, can we book you for company events, wedding parties, group outings, etc?
        </p>
        <p className="text-base font-body leading-normal">Sure! We welcome groups of all sizes and kinds. Lets chat over <a href="mailto:info@seattlebybike.com" className="text-grey-darkest hover:text-brand-orange">email</a>.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">What sizes are your bikes?
        </p>
        <p className="text-base font-body leading-normal">We are partnered with <a href="http://www.recycledcycles.com" target="_blank" className="text-grey-darkest hover:text-brand-orange">Recycled Cycles</a>, a local bike shop that has been around since 1994. They provide us with a wide range of bike sizes and can accommodate guests from 4’10” to 6’9” in height.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">How difficult are the bike tours?
        </p>
        <p className="text-base font-body leading-normal">Both the Emerald City Tour and Lake Union Loop have stops built in every 5-10 minutes and both are relatively flat with a few gentle hills. These tours are accessible to anyone comfortable on a bicycle and comfortable being active, with breaks included, over the course of three hours. The Lake Washington Scenic Ride is meant for folks who ride regularly. Road bikes are included for this tour. It has stops built in every 15-20 minutes and is flat for two thirds of the ride and hilly for one third. The total elevation gain/loss is 1082 feet.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">Can I bring my own bike?
        </p>
        <p className="text-base font-body leading-normal">Yes! You can bring your own bike. There is a discount of $20 if you bring your own bike. Bike helmets are required, though, so bring your helmet or rent one at our meeting location Recycled Cycles for $5.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">Okay, so what about a ride sharing bike (Lime, Ofo, etc)?
        </p>
        <p className="text-base font-body leading-normal">You can rent and bring a share bike like LimeBike or Ofo and get the BYOB discount, but they are not recommended for our tours. We tried them out and think they are too heavy and too often not working properly.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">What is your cancellation policy?
        </p>
        <p className="text-base font-body leading-normal">We have a 24 hour Full Refund Policy. You can cancel or change your reservation any time up to 24 hours before your tour start time. Inside of 24 hours from the start of your tour, there are no refunds, exchanges, or exceptions.
        </p>
      </div>

      <div className="px-6 py-4">
        <p className="font-bold font-title">Where do we meet?
        </p>
        <p className="text-base font-body leading-normal">We will meet at Recycled Cycles <a href="https://goo.gl/maps/8XcU6wEHMAL2" target="_blank" className="text-grey-darkest hover:text-brand-orange">(1007 NE Boat St, Seattle, WA 98105)</a>, which is located in between the neighborhoods of Fremont and Wallingford, on the north shore of Lake Union in Seattle. There is limited free parking in the neighborhood around Recycled Cycles. There is also a paid parking lot directly across the street, and ridesharing (Uber, Lyft, etc) are always a good option in Seattle.
        </p>
      </div>

      
  </div>
</div>
);

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ/index.js